import { m as minutesToMilliseconds, i as isSameDay, c as formatDate, d as millisecondsToDateParts } from '../../millisecondsToDateParts-8e4a9313.js';
export { e as dateFormatMap, c as formatDate, d as millisecondsToDateParts, m as minutesToMilliseconds } from '../../millisecondsToDateParts-8e4a9313.js';
import { c as __makeTemplateObject, _ as __assign } from '../../tslib.es6-896f83a9.js';
import { p as pluralize } from '../../pluralize-909fde53.js';

var daysToMilliseconds = function (days) { return days * 24 * 60 * 60 * 1000; };

var hoursToMilliseconds = function (hours) { return hours * 60 * 60 * 1000; };

var millisecondsToMinutes = function (milliseconds) { return milliseconds / (1000 * 60); };

var timeToHoursAndMinutes = function (value) {
    var _a = value.split(':').map(function (x) { return +x; }), hours = _a[0], minutes = _a[1];
    return [hours, minutes];
};

var durationInMinutes = function (startTime, endTime) {
    var _a = timeToHoursAndMinutes(startTime), startHours = _a[0], startMinutes = _a[1];
    var startInMs = hoursToMilliseconds(startHours) + minutesToMilliseconds(startMinutes);
    var _b = timeToHoursAndMinutes(endTime), endHours = _b[0], endMinutes = _b[1];
    var endInMs = hoursToMilliseconds(endHours) + minutesToMilliseconds(endMinutes);
    if (endInMs < startInMs) {
        endInMs += daysToMilliseconds(1);
    }
    var durationInMs = endInMs - startInMs;
    return millisecondsToMinutes(durationInMs);
};

var endFormatMap = {
    date: 'date',
    short: 'shortTime',
    medium: 'mediumTime',
    long: 'longTime',
    full: 'fullTime',
    shortDate: 'shortDate',
    mediumDate: 'mediumDate',
    longDate: 'longDate',
    fullDate: 'fullDate',
    shortTime: 'shortTime',
    mediumTime: 'mediumTime',
    longTime: 'longTime',
    fullTime: 'fullTime',
    dateTime: 'dateTime',
    yearMonth: 'yearMonth'
};
var formatDateSpan = function (start, end, format) {
    return isSameDay(start, end) ? formatDate(start, format) + " - " + formatDate(end, endFormatMap[format]) : formatDate(start, format) + " - " + formatDate(end, format);
};

var format = function (value, unit) { return "" + (value > 0 ? "" + value + unit + " " : ''); };
var formatDuration = function (_a) {
    var _b = _a.days, days = _b === void 0 ? 0 : _b, _c = _a.hours, hours = _c === void 0 ? 0 : _c, _d = _a.minutes, minutes = _d === void 0 ? 0 : _d, _e = _a.seconds, seconds = _e === void 0 ? 0 : _e, _f = _a.excludeSeconds, excludeSeconds = _f === void 0 ? true : _f;
    var totalSeconds = Math.round(days * 24 * 60 * 60 + hours * 60 * 60 + minutes * 60 + seconds);
    if (totalSeconds == 0) {
        return '0m';
    }
    var isNegative = totalSeconds < 0;
    var secondsToUse = Math.abs(totalSeconds);
    var h = Math.floor(secondsToUse / 3600);
    var m = Math.floor((secondsToUse % 3600) / 60);
    var s = Math.floor((secondsToUse % 3600) % 60);
    var result = ("" + format(h, 't') + format(m, 'm') + (excludeSeconds ? '' : format(s, 's'))).trim();
    return isNegative
        ? '-' + result
        : result;
};

var roundTimes = function (time) { return Number(Math.round(Number(time.toString(10) + 'e2')) + 'e-2').toFixed(2); };

var toDate = function (date) { return date ? new Date(date) : undefined; };

var formatTimeOffset = function (millisecondsFromMonday) {
    var weekdays = ['Måndag', 'Tisdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lördag', 'Söndag'];
    var _a = millisecondsToDateParts(millisecondsFromMonday), days = _a.days, hours = _a.hours, minutes = _a.minutes;
    var weeks = Math.trunc(days / 7);
    return weekdays[days % 7] + " " + hours.toString().padStart(2, '0') + ":" + minutes.toString().padStart(2, '0') + (weeks > 0 ? pluralize(templateObject_1 || (templateObject_1 = __makeTemplateObject([" (+", " [vecka|veckor])"], [" (+", " [vecka|veckor])"])), weeks) : '');
};
var templateObject_1;

var formatTimeSpan = function (data, options) {
    if (data == null) {
        return (options === null || options === void 0 ? void 0 : options.nullText) || 'Ej angivet';
    }
    var durationData = {
        'DAY': { days: data.value },
        'HOUR': { hours: data.value },
        'MINUTE': { minutes: data.value },
        'SECOND': { seconds: data.value },
        'MILLISECOND': { seconds: data.value * 1000 },
        'TICK': { seconds: data.value * 1000 * 10000 }
    }[data.unit];
    return formatDuration(__assign(__assign({}, durationData), { excludeSeconds: (options === null || options === void 0 ? void 0 : options.includeSeconds) == null || !options.includeSeconds }));
};

export { daysToMilliseconds, durationInMinutes, endFormatMap, formatDateSpan, formatDuration, formatTimeOffset, formatTimeSpan, hoursToMilliseconds, millisecondsToMinutes, roundTimes, timeToHoursAndMinutes, toDate };
//# sourceMappingURL=index.js.map
